<template>
    <div
        class="flex text-center w-fit items-center px-2 py-1 space-x-1 text-sm rounded-md text-branding-rich-black border cursor-pointer hover:bg-gray-200 border-action-gray bg-branding-smoke border-none shadow-[0px_1px_2px_0px_rgba(0,0,0,0.1)] transition-all duration-300"
    >
        <span class="break-all"> {{ badge.email }}</span>
        <!-- Adding one px at the top as for some reason it dont want to align with the mail -->
        <a class="text-center pt-[1px]">
            <i
                class="fa-solid fa-xmark text-sm text-center text-gray-400"
                @click="$emit('remove', badge.id)"
            ></i
        ></a>
    </div>
</template>
<script lang="ts" setup>
    defineProps<{
        badge: { id: string; email: string };
    }>();

    defineEmits<{
        (e: 'remove', value: string): void;
    }>();
</script>
